@let controls = variation().form.controls;
<div class="grid grid-cols-1 md:grid-cols-2 gap-6">
  @if (showActions()) {
  <div>
    <cac-image-uploader class="w-36 h-36 mx-auto md:mx-0" label="Image" [control]="controls.imagePath" />
  </div>
  }
  <div class="flex flex-col justify-start">
    @if (stockReadOnly()) {
    <span class="text-sm font-medium text-gray-700">Stock</span>
    <div class="mt-2 min-h-10 flex items-center px-3 border border-gray-200 rounded-md bg-gray-50 text-sm text-gray-700">
      @if (stockReadOnlyValue() === undefined) {
      Waiting for component stock
      } @else if (stockReadOnlyValue() === null) {
      Unlimited
      } @else {
      {{ stockReadOnlyValue() }}
      }
    </div>
    } @else {
    <cac-switch [control]="controls.isManageableStock" label="Manageable Stock" class="mt-0 md:mt-0" />
    @if (controls.isManageableStock.getValue()) {
    <div class="mt-3">
      <cac-field [control]="controls.stock" label="Stock" type="number" />
    </div>
    }
    }
  </div>
  
  @if (!showActions()) {
    <div class="md:col-span-2"></div>
  }
</div>

<!-- Identifiers Section -->
<div class="mt-6">
  <h3 class="text-base font-medium mb-4">Identifiers</h3>
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
    <cac-field [control]="controls.sku" label="SKU" />
    <cac-field [control]="controls.barcode" label="Barcode" />
    <cac-field [control]="controls.itemCode" label="Item Code" />
    <cac-field [control]="controls.model" label="Article" />
  </div>
</div>

<!-- Price Section -->
<div class="mt-6">
  <h3 class="text-base font-medium mb-4">Price</h3>
  <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
    <cac-field [control]="controls.regularPrice" [label]="regularPriceLabel()" suffix="KWD" placeholder="0.000" />
    <cac-field [control]="controls.salePrice" label="Sale Price (KWD)" suffix="KWD" placeholder="0.000" />
    @if (controls.salePrice.value != null) {
      <label class="flex flex-col gap-1 text-sm">Discount Expiration Date and Time (UTC)
        <input type="datetime-local" [formControl]="controls.discountExpiresAtUtc" class="h-10 border rounded px-2 bg-transparent" />
      </label>
    }
    <cac-field [control]="controls.costPrice" label="Cost Price (KWD)" suffix="KWD" placeholder="0.000" />
  </div>
</div>

<!-- Shipping Info Section -->
<div class="mt-6">
  <h3 class="text-base font-medium mb-4">Shipping Info</h3>
  <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
    <cac-field [control]="controls.weight" label="Weight" />
    <cac-field [control]="controls.length" label="Length" />
    <cac-field [control]="controls.width" label="Width" />
    <cac-field [control]="controls.height" label="Height" />
  </div>
</div>


@if (showActions()) {
  <div class="flex justify-end mt-6">
    <cac-button (click)="delete.emit()" class="w-40">Delete</cac-button>
  </div>
}
